module.exports = __webpack_public_path__ + "img/logo.9ae32320.png";